import { render, staticRenderFns } from "./AggregateList.vue?vue&type=template&id=70176a62"
import script from "./AggregateList.vue?vue&type=script&lang=js"
export * from "./AggregateList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports